import { API_URL } from "../constants";
import * as httpNetworking from "../httpNetworking";

const URL = API_URL + "/website/form/consultation";
const VERSION = 0;

export default async function consultAnExpert({
    ...data
}: {
    name: string;
    email: string;
    field?: string;
}): Promise<void> {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 50000
    };
    await httpNetworking.simplePOSTRequest(URL, data, options, VERSION);
}
